exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:Material Icons;font-style:normal;font-weight:400;src:url(" + require("./fonts/MaterialIcons-Regular.eot") + ");src:local(\"Material Icons\"),local(\"MaterialIcons-Regular\"),url(" + require("./fonts/MaterialIcons-Regular.woff2") + ") format(\"woff2\"),url(" + require("./fonts/MaterialIcons-Regular.woff") + ") format(\"woff\"),url(" + require("./fonts/MaterialIcons-Regular.ttf") + ") format(\"truetype\")}.material-icons{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;width:1em;height:1em;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:\"liga\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/resolve-url-loader!./~/sass-loader?sourceMap!./~/material-design-icons-iconfont/dist/material-design-icons.scss
// module id = 61
// module chunks = 0